import styled from 'styled-components';

import { getFontWeight, getLineHeight, getSpace } from '@yoweb/ui/styles/utils/theme';

export const H3LegalSpaced = styled.h3`
  && {
    margin-top: ${getSpace('normal1')};
    line-height: ${getLineHeight('bodyLg')};
    font-weight: ${getFontWeight('semibold')};
  }
`;
H3LegalSpaced.defaultProps = {};
